import { render } from "./MyCardsView.vue?vue&type=template&id=9cd4987a&scoped=true"
import script from "./MyCardsView.vue?vue&type=script&lang=js"
export * from "./MyCardsView.vue?vue&type=script&lang=js"

import "./MyCardsView.vue?vue&type=style&index=0&id=9cd4987a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd4987a"]])

export default __exports__